export default __webpack_public_path__ + "static/media/Mantle of Eleven Resplendent Prayers.c1373402.jpg";